// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageBlocks .message-block-paginator {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/components/MessageBlocks/MessageBlocks.scss"],"names":[],"mappings":"AAEE;EACE,mBAAA;AADJ","sourcesContent":[".MessageBlocks {\n\n  .message-block-paginator {\n    margin-bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
